/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";
import {PointDtoModel} from "@well/address-management-domain-model";

export class DelAddressTemplateListVO extends JSONable {
  uuid: string | undefined = undefined;
  owner: string | undefined = undefined;
  addressLine: string | undefined = undefined;
  streetName: string | null = null;
  streetNumber: string | null = null;
  block: string | null = null;
  building: string | null = null;
  floor: string | null = null;
  apartment: string | null = null;
  city: string | null = null;
  cityCode: string | null = null;
  state: string | null = null;
  countyCode: string | null = null;
  country: string | null = null;
  details: string | null = null;
  postalCode: string | null = null;
  pointDTO: PointDtoModel | undefined = undefined;
  visibilityType: string | null = null;
  addressLabel: string | null = null;
  forCompany: string | null = null;
  businessProfileUuid: string | null = null;
}
